export default {
  // 表单新增运费明细 WLF_ADD_01
  insertWlFreight: '/ygsjzs/wlFreight/insertWlFreight',
  // 通过物流计划新增运费明细 WLF_ADD_02
  insertWlFreightByPlan: '/ygsjzs/wlFreight/insertWlFreightByPlan',
  // 修改运费明细 WLF_EDT_01
  updateWlFreight: '/ygsjzs/wlFreight/updateWlFreight',
  // 将未结算的运费明细修改为已结算 WLF_EDT_02
  updateSettlementStatus: '/ygsjzs/wlFreight/updateSettlementStatus',
  // 删除运费明细 WLF_DEL_01
  deleteDataWlFreight: '/ygsjzs/wlFreight/deleteDataWlFreight',
  // 运费明细详情 WLF_SEL_01
  selectWlFreightByFreightId: '/ygsjzs/wlFreight/selectWlFreightByFreightId',
  // 分页查询运费明细 WLF_SEL_02
  selectWlFreightByPage: '/ygsjzs/wlFreight/selectWlFreightByPage',
  // 导出运费明细 WLF_SEL_03
  exportWlFreight: '/ygsjzs/wlFreight/exportWlFreight'
}
